// extracted by mini-css-extract-plugin
export default {"logoutIcon":"LogoutButton_logoutIcon__QELYX"};